import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { setData, setDrawer, setDrawerAlert, setStage } from 'slices/drawer'
import { STATICS } from 'statics'
import {
  DEFAULT_ERROR_MESSAGE,
  DRAWER_KEY,
  EVENT_STATUS,
  FIREBASE_EVENTS,
  NEW_VIRTUAL_SUPPORT_STAGES,
  SCHEDULING_SHIFT_LABEL,
} from 'app-constants'
import { Button } from 'components'
import { useFirebaseEvent } from 'hooks'
import { formatDate } from 'utils'
import { bookingService } from 'services'
import './style.scss'

export function ScheduleConfirmation({
  bookingSelected,
  contractAddressSelected,
  contactNote,
  serviceOrderMassive,
}) {
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)
  const { sendEvent } = useFirebaseEvent()
  const {
    date,
    turn,
    reference,
    scheduleId,
    timeFrames: { initialTimeFrame, finalTimeFrame },
    bookingCode,
    bucket,
    firstAvailableDate,
    workZoneCode,
  } = bookingSelected
  const { unity, id: contractId } = contractAddressSelected
  const { sendBookingsRepair } = bookingService()

  async function handleRequestVisit() {
    const event = serviceOrderMassive
      ? FIREBASE_EVENTS.UNITARY_WARNING_REPAIR_CONFIRM
      : FIREBASE_EVENTS.VIRTUAL_SUPPORT_SCHEDULE_CONFIRMATION
    try {
      setIsLoading(true)
      const params = {
        contractId,
        date,
        reference,
        scheduleId,
        shift: turn,
        unity,
        code: bookingCode,
        initialTimeFrame,
        finalTimeFrame,
        bucket,
        firstAvailableDate,
        workZoneCode,
        contactNote,
      }

      await sendBookingsRepair(params)
      sendEvent(event)
      dispatch(setStage(NEW_VIRTUAL_SUPPORT_STAGES.SCHEDULING_SUCCESS))
    } catch (error) {
      console.error(error)
      const errorMessage = error?.response?.data?.error || DEFAULT_ERROR_MESSAGE
      const errorStatus = error?.response?.status
      const isMassiveUser = error?.response?.data?.clienteEmMassiva
      const isMassiveStatus = errorStatus === 409
      sendEvent(event, EVENT_STATUS.ERROR, error?.response?.status)
      if (isMassiveUser && isMassiveStatus) {
        dispatch(setData({ message: errorMessage }))
        dispatch(setDrawer(DRAWER_KEY.OS_BLOCK))
      } else dispatch(setDrawerAlert({ severity: 'error', title: errorMessage }))
    } finally {
      setIsLoading(false)
    }
  }

  function handleTalkAttendant() {
    dispatch(setStage(NEW_VIRTUAL_SUPPORT_STAGES.REDIRECT_CHAT))
  }

  function renderButton() {
    return (
      <div className='links'>
        <Button
          className='button'
          color='primary'
          size='large'
          isLoading={isLoading}
          disabled={isLoading}
          onClick={() => handleRequestVisit()}
        >
          Solicitar visita
        </Button>
        <Button
          className='button'
          color='primary'
          size='large'
          isLoading={isLoading}
          disabled={isLoading}
          outlined
          onClick={() => handleTalkAttendant()}
        >
          Falar com atendimento
        </Button>
      </div>
    )
  }

  return (
    <div className='schedule-confirmation'>
      <div className='content'>
        <h3 className='title'>Resumo da sua solicitação</h3>
        <div className='info-confirmation'>
          <p className='text'>
            Você solicitou uma visita técnica para reparo da sua internet, confira a data agendada:
          </p>
          <div className='container-schedule'>
            <div>
              <h4 className='info-text'>Data de agendamento:</h4>
              <p className='info-text'>{formatDate(date)}</p>
            </div>
            <div>
              <h4 className='info-text'>Turno:</h4>
              <p className='info-text'>
                {SCHEDULING_SHIFT_LABEL[turn]} ({initialTimeFrame} - {finalTimeFrame})
              </p>
            </div>
          </div>
          {reference && (
            <div className='reference'>
              <h4 className='text'>Referência:</h4>
              <p className='text'>{reference}</p>
            </div>
          )}
          <div className='alert'>
            <div className='icon-alert'>
              <STATICS.INFO_OUTLINE />
            </div>
            <p className='alert-schedule'>
              Caso deseje alterar a data agendada entre em contato com o atendimento.
            </p>
          </div>
        </div>
      </div>
      {renderButton()}
    </div>
  )
}
